import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { PaymentPageComponent } from './payments/payments';
import { SplitPaymentPageComponent } from './split-payment/split-payment';
import { SplitBillOptionsSheet } from './split-bill-options.sheet/split-bill-options.sheet';
import { SplitEvenlyComponent } from './split-payment/split-evenly/split-evenly';
import { SplitCustomAmountComponent } from './split-payment/split-custom-amount/split-custom-amount';
import { SplitItemsComponent } from './split-payment/split-items/split-items';



@NgModule({
  declarations: [
    PaymentPageComponent,
    SplitPaymentPageComponent,
    SplitBillOptionsSheet,
    SplitEvenlyComponent,
    SplitCustomAmountComponent,
    SplitItemsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],

})
export class PayAtTableModule { }
